import styled from 'styled-components';
import { Swiper } from 'swiper/react';
import { Link } from 'react-router-dom';

export const NewsSection = styled.section`
  padding: 2rem;
  background: #f8f8f8;

  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2.5rem;
    margin-bottom: 2rem;
    text-align: center;
  }
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  padding-bottom: 2rem;
  box-sizing: border-box;

  .swiper-slide {
    transition: transform 0.5s ease;
    opacity: 0.6;
    transform: scale(0.9);
  }

  .swiper-slide-active {
    opacity: 1;
    transform: scale(1);
  }
`;

export const NewsSlide = styled.div`
  height: 400px;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
`;

export const NewsContent = styled.div`
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 1.5rem;
  width: 100%;
  box-sizing: border-box;

  h3 {
    margin: 0 0 0.5rem;
    font-size: 1.5rem;
  }

  p {
    margin: 0;
    font-size: 1rem;
  }
`;

export const SeeMoreLink = styled(Link)`
  color: #FF457D;
  text-decoration: underline;
  font-weight: bold;
  margin-top: 0.5rem;
  display: inline-block;
`;
